import { createContext, useContext, useEffect, useState } from "react";
import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";
import { useSearchParams } from "react-router-dom";

const RoiIndustryContext = createContext();

const RoiIndustryProvider = ({ children }) => {
  const [filteredIndustries, setFilteredIndustries] = useState([]);
  const [showStocks, setShowStocks] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState({
    id: "",
    name: "",
  });

  const [searchParams] = useSearchParams();

  const { data: industries, isLoading } = useSWR(
    "/stock-market/industry-roi",
    fetchData
  );

  const query = searchParams.get("query");
  const roiPeriod = searchParams.get("roi_period");
  const sortType = searchParams.get("sort");

  useEffect(() => {
    if (industries) {
      let filteredItems = [...industries];

      // فیلتر بر اساس جستجو
      if (query) {
        filteredItems = filteredItems.filter((data) =>
          data.industrial_group_name.toLowerCase().includes(query.toLowerCase())
        );
      }

      filteredItems.sort((a, b) => {
        const roiA = a[roiPeriod || "quarterly_roi"];
        const roiB = b[roiPeriod || "quarterly_roi"];

        return sortType === "descending" ? roiA - roiB : roiB - roiA;
      });

      setFilteredIndustries(filteredItems);
    }
  }, [query, roiPeriod, sortType, industries]);

  return (
    <RoiIndustryContext.Provider
      value={{
        filteredIndustries,
        showStocks,
        setShowStocks,
        selectedIndustry,
        setSelectedIndustry,
        isLoading,
      }}
    >
      {children}
    </RoiIndustryContext.Provider>
  );
};

export default RoiIndustryProvider;

export const useRoiIndustryContext = () => useContext(RoiIndustryContext);
